"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PointRestrictionApi_pointRestriction;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointRestrictionApi = void 0;
const AbstractRestrictionApi_1 = require("../AbstractRestrictionApi");
class PointRestrictionApi extends AbstractRestrictionApi_1.AbstractRestrictionApi {
    // #endregion Properties (1)
    // #region Constructors (1)
    constructor(restriction) {
        super(restriction);
        // #region Properties (1)
        _PointRestrictionApi_pointRestriction.set(this, void 0);
        __classPrivateFieldSet(this, _PointRestrictionApi_pointRestriction, restriction, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (2)
    get point() {
        return __classPrivateFieldGet(this, _PointRestrictionApi_pointRestriction, "f").point;
    }
    get radius() {
        return __classPrivateFieldGet(this, _PointRestrictionApi_pointRestriction, "f").radius;
    }
}
exports.PointRestrictionApi = PointRestrictionApi;
_PointRestrictionApi_pointRestriction = new WeakMap();
//# sourceMappingURL=PointRestrictionApi.js.map